const styles = () => ({
  layout: {
    display: 'flex',
    flexGrow: 1,
    minHeight: 0,
    flexDirection: 'column',
    overflow: 'auto',
    minWidth: 0,
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    top: 0,
    background: 'white',
    zIndex: 10,
    flexShrink: 0,
  },

  darkHeader: {
    background: '#FAFBFC',
  },

  border: {
    borderBottom: '1px solid #e1e9f0',
  },

  contentSection: {
    padding: '0px 40px 0px',
  },

  shadow: {
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.05)',
  },

  info: {
    alignItems: 'center',
    display: 'flex',
    padding: '30px 40px',
  },

  tabs: {
    /*
     * Negative margins are generally not recommended but in this case it seems
     * a good enough compromise. The alternative is to define all margins for
     * each case to support tabs here./
     */
    margin: '-10px 40px -1px',
    zIndex: 10,
  },

  accessoryView: {
    padding: 16,
    margin: '0 24px',
    borderTop: '1px solid rgba(225,233,240,0.50)',
  },

  contents: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '100%',
  },

  tile: {
    margin: '-2px 15px 0 0',
    maxHeight: 50,
    flexShrink: 0,
  },

  titles: {
    marginRight: 'auto',
    minWidth: 0,
  },

  title: {
    color: '#27282A',
    fontSize: 24,
    fontWeight: 600,
    margin: 0,
    whiteSpace: 'pre',
    textOverflow: 'ellipsis',
    flexGrow: 1,
    overflow: 'hidden',
  },

  subtitle: {
    color: '#596168',
    fontSize: 15,
    margin: 0,
    whiteSpace: 'pre',
    textOverflow: 'ellipsis',
    flexGrow: 1,
    overflow: 'hidden',

    '& strong': {
      fontWeight: 600,
    },
  },

  actions: {
    marginLeft: 16,
    flex: '0 0 auto',
  },

  back: {
    fontSize: 24,
    color: '#596168',
    fontWeight: 400,
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  arrow: {
    display: 'inline-block',
    verticalAlign: 'middle',
    position: 'relative',
    top: -2,
    margin: '0 10px',
  },
});

export default styles;
